import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

const useChatPageData = () => {
  const [chatPageData, setChatPageData] = useState(null);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchChatPageData = async () => {
      try {
        const docRef = doc(db, "chatData", "BUuLcnbkHPJs4iph9uum");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setChatPageData(docSnap.data());
        } else {
          console.error("No such chat page document!");
        }
      } catch (error) {
        console.error("Error fetching chat page data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchChatPageData();
  }, []);

  return {
    ...chatPageData,
    loading,
  };
};

export default useChatPageData;
